/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRiskPolicyRequestBody,
  UpdateRiskPolicyRequestBody$Outbound,
  UpdateRiskPolicyRequestBody$outboundSchema,
} from "../components/updateriskpolicyrequestbody.js";

export type UpdateRiskPolicySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateRiskPolicySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateRiskPolicySecurity = {
  option1?: UpdateRiskPolicySecurityOption1 | undefined;
  option2?: UpdateRiskPolicySecurityOption2 | undefined;
};

export type UpdateRiskPolicyRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateRiskPolicyRequestBody: UpdateRiskPolicyRequestBody;
};

/** @internal */
export type UpdateRiskPolicySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateRiskPolicySecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateRiskPolicySecurityOption1$Outbound,
  UpdateRiskPolicySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateRiskPolicySecurityOption1ToJSON(
  updateRiskPolicySecurityOption1: UpdateRiskPolicySecurityOption1,
): string {
  return JSON.stringify(
    UpdateRiskPolicySecurityOption1$outboundSchema.parse(
      updateRiskPolicySecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateRiskPolicySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateRiskPolicySecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateRiskPolicySecurityOption2$Outbound,
  UpdateRiskPolicySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateRiskPolicySecurityOption2ToJSON(
  updateRiskPolicySecurityOption2: UpdateRiskPolicySecurityOption2,
): string {
  return JSON.stringify(
    UpdateRiskPolicySecurityOption2$outboundSchema.parse(
      updateRiskPolicySecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateRiskPolicySecurity$Outbound = {
  Option1?: UpdateRiskPolicySecurityOption1$Outbound | undefined;
  Option2?: UpdateRiskPolicySecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateRiskPolicySecurity$outboundSchema: z.ZodMiniType<
  UpdateRiskPolicySecurity$Outbound,
  UpdateRiskPolicySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateRiskPolicySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateRiskPolicySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateRiskPolicySecurityToJSON(
  updateRiskPolicySecurity: UpdateRiskPolicySecurity,
): string {
  return JSON.stringify(
    UpdateRiskPolicySecurity$outboundSchema.parse(updateRiskPolicySecurity),
  );
}

/** @internal */
export type UpdateRiskPolicyRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateRiskPolicyRequestBody: UpdateRiskPolicyRequestBody$Outbound;
};

/** @internal */
export const UpdateRiskPolicyRequest$outboundSchema: z.ZodMiniType<
  UpdateRiskPolicyRequest$Outbound,
  UpdateRiskPolicyRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateRiskPolicyRequestBody: UpdateRiskPolicyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateRiskPolicyRequestBody: "UpdateRiskPolicyRequestBody",
    });
  }),
);

export function updateRiskPolicyRequestToJSON(
  updateRiskPolicyRequest: UpdateRiskPolicyRequest,
): string {
  return JSON.stringify(
    UpdateRiskPolicyRequest$outboundSchema.parse(updateRiskPolicyRequest),
  );
}
